import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Button from "@mui/material/Button";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { styled } from "@mui/material/styles";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import * as util from "../../utils/util";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { BarChart } from '@mui/x-charts/BarChart';

const HealthResultItem = (props: any) => {
  type Anchor = 'bottom'
  const [state, setState] = React.useState({
    bottom: false,
  });
  const [categoryB, setCategoryB] = React.useState<string[]>([]);
  const [categoryA, setCategoryA] = React.useState<string[]>([]);

  useEffect(() => {

    const resultByCategoryA = props.resultItemData.reduce((acc: any, curr: any) => {
      const { categoryA } = curr;
      if (acc[categoryA]) acc[categoryA].push(curr);
      else acc[categoryA] = [curr];
      return acc;
    }, {});
    setCategoryA(Object.keys(resultByCategoryA));

    const resultByCategoryB = props.resultItemData.reduce((acc: any, curr: any) => {
      const { categoryB } = curr;
      if (acc[categoryB]) acc[categoryB].push(curr);
      else acc[categoryB] = [curr];
      return acc;
    }, {});
    setCategoryB(Object.keys(resultByCategoryB));

  }, []);

  const toggleDrawer = (anchor: Anchor, open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };



  const [value, setValue] = React.useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);






  };

  return (
    <React.Fragment>
      {(['bottom'] as const).map((anchor) => (
        <React.Fragment key={anchor}>

          {props.componentName === '전체 검진결과 보기' ? (
            <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#f18322', p: 1 }} onClick={toggleDrawer(anchor, true)}>
              <Typography sx={{ fontWeight: 700, color: '#fff' }}>전체 검진결과 보기  <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#fff' }} /></Typography>
            </Box>
          ) : (
            <Button onClick={toggleDrawer(anchor, true)} sx={{ p: 0 }}>
              <Stack alignItems={'center'} spacing={1} sx={resultIconBtn}>
                <Img alt="" src={props.src} sx={{ width: props.width }} />
                <Typography dangerouslySetInnerHTML={{ __html: props.componentName }}></Typography>
              </Stack>
            </Button>
          )}

          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            <Box
              sx={{ pb: 7, }}
              role="presentation"
              onKeyDown={toggleDrawer(props.anchor, false)}
            >
              <Stack direction={'row'} justifyContent={'center'} mb={1} p={2} sx={{ position: 'fixed', width: '100%', bgcolor: '#fff', zIndex: 1, boxSizing: 'border-box', borderBottom: '1px solid #ccc' }}>
                <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', }}>{props.componentName.replaceAll('<br />', ' / ')}</Typography>
                <Typography sx={{ fontSize: 18, fontWeight: 700, ml: 'auto', mr: 1, color: '#777' }} onClick={toggleDrawer(props.anchor, false)}>X</Typography>
              </Stack>


              <React.Fragment>
                <Box sx={{ bgcolor: '#fff', p: 1, textAlign: 'right', pr: 2, pt: 10 }}>
                  <Typography sx={{ fontSize: 14, }}>검진항목 <Typography component={'span'} sx={{ fontSize: 14, fontWeight: 700 }}>{props.resultItemData.length}</Typography>개</Typography>
                </Box>
                <Divider />

                {categoryB.length <= 0 ? (
                  <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{ mt: 10, }}>
                    <EventBusyIcon sx={{ fontSize: 50, color: '#bbb' }} />
                    <Typography sx={{ fontSize: 16, color: '#888' }} >{props.componentName.replaceAll('<br />', ' / ')} 정보가 없습니다.</Typography>
                  </Stack>
                ) : (
                  <React.Fragment>
                    {categoryA && categoryA.map((itemA: any, index: any) => (
                      <Box sx={{ mt: 3, }}>
                        <Typography pl={3} sx={mainTitle}>{itemA}</Typography>
                        <Box sx={{ p: 2, bgcolor: '#f9f9f9', }}>
  
  
                          {categoryB && categoryB.map((itemB: any, index: any) => (
                            <React.Fragment>
  
                              {props.resultItemData.filter((v: any) => v.categoryA === itemA && v.categoryB === itemB).map((item: any, index: any) => (
                                item.resultCase === 'A' ? (
                                  <React.Fragment>
                                    {/* {index === 0 ? <Divider sx={titleDivider} ><Chip label={itemB}/></Divider> : null} */}
                                    {index === 0 ? <Divider sx={titleDivider} >{itemB}</Divider> : null}
  
                                    <Card sx={resultBox}>
                                      <Stack direction={'row'} justifyContent={'space-around'} mt={1}>
                                        <Typography sx={resultTitle}>{item.inspection}</Typography>
  
                                        <Divider orientation="vertical" flexItem sx={divider} />
  
                                        <Typography sx={result}>{util.strNull(item.result).trim() !== '' ? item.result : '-'}
                                          <Typography component={'span'} sx={resultUnit}>{item.unit}</Typography>
                                        </Typography>
                                      </Stack>
                                    </Card>
  
                                  </React.Fragment>
                                ) : (
                                  <React.Fragment>
                                    {index === 0 ? <Divider sx={titleDivider} >{itemB}</Divider> : null}
                                    <Card sx={resultChartBox}>
                                      
                                    {
                                      item.inspection === '비만도(BMI)'
                                        ? <Stack direction={'row'} alignItems={'center'}>
                                          <Typography sx={resultTitle}>{item.inspection}</Typography>
                                          <Box sx={{ ml: 'auto' }}>
                                            <Chip
                                              label={
                                                item.result < '18.5' ? '저체중' : item.result >= '18.5' && item.result < '23.0' ? '정상' : item.result >= '23.0' && item.result < '25.0' ? '과체중' : item.result >= '25.0' && item.result < '30.0' ? '비만' : item.result >= '30.0' ? '고도비만' : ''
                                              }
                                              color="primary"
                                              size='small'
                                              sx={{
                                                bgcolor: item.result < '18.5' ? 'rgb(189, 186, 26)' : item.result >= '18.5' && item.result < '23.0' ? 'rgb(0, 170, 0)' : item.result >= '23.0' && item.result < '25.0' ? 'rgb(179, 95, 214)' : item.result >= '25.0' && item.result < '30.0' ? 'rgb(255, 85, 85)' : item.result >= '30.0' ? 'rgb(229,36,36)' : '',
                                                fontSize: 12,
                                              }}
                                            />
                                          </Box>
                                        </Stack>
                                        : <Stack direction={'row'} alignItems={'center'}>
                                          <Typography sx={resultTitle}>{item.inspection}</Typography>
                                          <Box sx={{ ml: 'auto' }}>
                                            <Chip label={item.resultCase === 'B' ? (
                                              item.resultRatio < 33 ? '낮음' : item.resultRatio >= 33 && item.resultRatio <= 66 ? '정상' : item.resultRatio > 66 ? '높음' : ''
                                            ) : (
                                              item.resultRatio < 50 ? '비정상' : '정상'
                                            )} color="primary" size='small' sx={{
                                              bgcolor: item.resultCase === 'B' ? (
                                                item.resultRatio < 33 ? 'rgb(189,186,26)' : item.resultRatio >= 33 && item.resultRatio <= 66 ? '#2bbe43' : item.resultRatio > 66 ? '#ff6f6f' : ''
                                              ) : (
                                                item.resultRatio < 50 ? '#ff6f6f' : '#2bbe43'
                                              ), fontSize: 12,
                                            }} />
                                          </Box>
                                        </Stack>
                                      }
                                      
                                      {item.resultCase === 'B' ? (
                                        
                                        item.inspection === '비만도(BMI)'
                                          ? <Box sx={{ mt: 1 }}>
                                            <Box sx={{ width: '100%', textAlign: 'center' }}>
                                              <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                                <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {Number(item.result).toFixed(2)}</Typography>
                                                <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                              </Box>
                                            </Box>
      
                                            <Box sx={{ width: '100%', textAlign: 'center', display: 'flex', height: 10, alignItems: 'center', justifyContent: 'center', mt: -1.5, mb: 1 }}>
                                              <Box sx={{ backgroundColor: 'rgb(189, 186, 26)', width: '20%', fontSize: '12px', color: '#fff' }}>저체중</Box>
                                              <Box sx={{ backgroundColor: 'rgb(0, 170, 0)', width: '20%', fontSize: '12px', color: '#fff' }}>정상</Box>
                                              <Box sx={{ backgroundColor: 'rgb(179, 95, 214)', width: '20%', fontSize: '12px', color: '#fff' }}>과체중</Box>
                                              <Box sx={{ backgroundColor: 'rgb(255, 85, 85)', width: '20%', fontSize: '12px', color: '#fff' }}>비만</Box>
                                              <Box sx={{ backgroundColor: 'rgb(229,36,36)', width: '20%', fontSize: '12px', color: '#fff' }}>고도비만</Box>
                                            </Box>
                                          </Box>
                                          : 
                                          <Box sx={{ mt: 1 }}>
                                            <Box sx={{ width: '100%', textAlign: 'center' }}>
                                              <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                                <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                                <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                              </Box>
                                            </Box>
          
                                            <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                              <Grid item xs={4} bgcolor={'rgb(189,186,26)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                낮음
                                              </Grid>
                                              <Grid item xs={4} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                정상
                                              </Grid>
                                              <Grid item xs={4} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                                높음
                                              </Grid>
                                            </Grid>
          
                                            <Box>
          
                                            </Box>
                                          </Box>
  
                                      ) : (
                                        <Box sx={{ mt: 1 }}>
                                          <Box sx={{ width: '100%', textAlign: 'center' }}>
                                            <Box sx={{ width: 'fit-content', ml: `calc(${item.resultRatio}% - 16px)`, }}>
                                              <Typography sx={{ bgcolor: '#d9e1ff', px: 1, py: .5, borderRadius: 3, fontWeight: 700, fontSize: 14, }}> {item.result}</Typography>
                                              <ArrowDropDownIcon sx={{ mt: -1.8, color: '#d9e1ff', fontSize: '2rem' }} />
                                            </Box>
                                          </Box>
  
                                          <Grid container spacing={0} height={10} sx={{ mt: -1.5, mb: 1 }}>
                                            <Grid item xs={6} bgcolor={'rgb(229,36,36)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                              비정상
                                            </Grid>
                                            <Grid item xs={6} bgcolor={'rgb(29,159,55)'} fontSize={12} color={'#fff'} sx={bmiStep}>
                                              정상
                                            </Grid>
                                          </Grid>
                                        </Box>
  
                                      )}
                                    </Card>
                                  </React.Fragment>
                                )
                              ))}
                            </React.Fragment>
                          ))}
                        </Box>
                      </Box>
                    ))}
                    
                    <Typography pl={3} mt={3} sx={mainTitle}>종합소견</Typography>

                    <Box sx={{ p: 2, bgcolor: '#f9f9f9', }}>
                      {props.totalResult && props.totalResult.map((item: any) => (
                        <Card sx={resultBox}>
                          <Typography sx={resultTotal}>{item}</Typography>
                        </Card>
                      ))}
                    </Box>
    
                    <Box sx={{ p: 2, bgcolor: '#f9f9f9', display: 'none' }}>
                      {props.totalResult && props.totalResult.map((item: any) => (
                        <Card sx={resultBox}>
                          <Typography sx={resultTotal}>{item}</Typography>
                        </Card>
                      ))}
                    </Box>
    
                    <Box sx={{ p: 2, bgcolor: '#f9f9f9', display: 'none' }}>
                      {props.totalResult && props.totalResult.map((item: any) => (
                        <Card sx={resultBox}>
                          <Typography sx={resultTotal}>{item}</Typography>
                        </Card>
                      ))}
                    </Box>
                  </React.Fragment>
                )}
              </React.Fragment>



            </Box>
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </React.Fragment>
  );
}

const mainTitle = {
  fontSize: 18,
  fontWeight: 700,
  mb: 1
}

const titleDivider = {
  mt: 1, mb: 2, fontWeight: 700,
  '& span': { bgcolor: '#ddd', borderRadius: 4, py: .5, px: 2, fontSize: 14 }
}

const resultBox = {
  p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', mb: 2
}

const resultChartBox = {
  p: 2, display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly', mb: 2
}

const resultTitle = {
  fontSize: 14,
  flex: 1,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const result = {
  fontSize: 14,
  fontWeight: 700,
  flex: 1,
  textAlign: 'left',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  mt: 1,
}

const resultUnit = {
  fontSize: 12,
  ml: .5
}

const divider = {
  mx: 1,
}

const resultTotal = {
  fontSize: 14,
}



const resultIconBtn = {
  bgcolor: '#f9f9f9', p: 1, borderRadius: 4, textAlign: 'center', width: 70, minHeight: 60,
  '& p': { fontSize: 12, color: '#555', textAlign: 'center' }
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const bmiStep = {
  p: '0 !important',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center'
}

export default HealthResultItem;